import { Pipe, PipeTransform } from '@angular/core';
import { ContentService } from '../../services/content/content.service';
import { Models } from '@ibexfusion/models';

@Pipe({
  name: 'socialMediaPipe'
})
export class SocialMediaPipe implements PipeTransform {
  public imageLink = 'https://s3.eu-central-1.amazonaws.com/tweebie-staging/assets/images/';

  constructor(private contentService: ContentService) {
  }

  transform(entry: Models.ContentEntry): Models.SocialMediaEntry | Models.SocialMediaEntry[] {
    const entries: Models.SocialMediaEntry[] = [];
    if (!entry) {
      return null;
    }

    if (entry.related && entry.related.entries && entry.related.entries.length > 0) {
      for (const item of entry.related.entries) {

        if (!this.contentService.getEntry(item.id)) {
          continue;
        }
        const contentEntry: any = this.contentService.getEntry(item.id);
        if (contentEntry && contentEntry.detail
          && contentEntry.files && contentEntry.files.length) {
          let file = this.contentService.getFile(contentEntry.files[0].id);
          if (file && file.url) {
            contentEntry.detail.image = file.url;
          }
        }
        const socialMediaEntry: any = new Models.SocialMediaEntry();
        socialMediaEntry.populateFromJSON({
          sourceId: contentEntry.getId(),
          title: contentEntry.title,
          description: contentEntry.detail.textContent,
          link: contentEntry.detail.link,
          otherLogo: contentEntry.detail.otherLogo,
          platform: contentEntry.detail.platform,
          media: this.contentService.getMediaEntriesForEntry(contentEntry.getId())
        })
        entries.push(socialMediaEntry);
      }
      return entries.length ? entries : null;
    }
    if (!entry.detail) {
      return null;
    }

    if (!this.contentService.isValid(entry)) {
      return null;
    }
  }
}
